/**
 * 現在のメディアクエリを判定
 * ※cssと連動したいため、HTML要素のcontentプロパティから取得します。
 * getComputedStyleを使って取得しますが、パフォーマンスに問題がある可能性があるため、
 * 問題が起きた場合は下部のコメントアウトした部分を使って静的な値を返してください。
 * 
 * @returns {String} config.scssで定義したメディアクエリ名 (xs~xl。max値(lg_max等)は含みません)
*/
const isCurrentMq = () => {
    const target = document.querySelector('.js_isCurrentMq');
    if (!target) return;

    const mqValue = window.getComputedStyle(target).content.replace(/"/g, '');
    return mqValue;

    // const mq = {
    //     sm: 375,
    //     md: 768,
    //     lg: 992,
    //     xl: 1200,
    // }

    // if (window.innerWidth < mq.sm) {
    //     return 'xs';
    // } else if (window.innerWidth < mq.md) {
    //     return 'sm';
    // } else if (window.innerWidth < mq.lg) {
    //     return 'md';
    // }  else if (window.innerWidth < mq.xl) {
    //     return 'lg';
    // } else {
    //     return 'xl';
    // }
}

export default isCurrentMq;